import { render, staticRenderFns } from "./mini-player.vue?vue&type=template&id=c03075dc&scoped=true&"
import script from "./mini-player.vue?vue&type=script&lang=js&"
export * from "./mini-player.vue?vue&type=script&lang=js&"
import style0 from "./mini-player.vue?vue&type=style&index=0&id=c03075dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03075dc",
  null
  
)

export default component.exports